import { render, staticRenderFns } from "./AddApplicant.vue?vue&type=template&id=6729874b&"
import script from "./AddApplicant.vue?vue&type=script&lang=js&"
export * from "./AddApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports